import { ImportStep } from './types'

export const IMPORT_STEP_ORDER: ImportStep[] = [
  'user:uploadFiles',
  'sending:uploadFiles',
  'polling:uploadStatus',
  'fetching:uploadDetails',
  'user:mapAndSelect',
  'sending:importData',
  'polling:importStatus',
  'fetching:importDetails',
  'user:confirmSummary',
]

export const getImportStepMessages = (
  t: (key: string) => string,
): Partial<Record<ImportStep, { title: string; description: string }>> => ({
  'sending:uploadFiles': {
    title: t('importModule.step-sending-upload-title'),
    description: t('importModule.step-sending-upload-desc'),
  },

  'polling:uploadStatus': {
    title: t('importModule.step-polling-upload-title'),
    description: t('importModule.step-polling-upload-desc'),
  },

  'fetching:uploadDetails': {
    title: t('importModule.step-fetching-details-title'),
    description: t('importModule.step-fetching-details-desc'),
  },

  'sending:importData': {
    title: t('importModule.step-sending-import-title'),
    description: t('importModule.step-sending-import-desc'),
  },

  'polling:importStatus': {
    title: t('importModule.step-polling-import-title'),
    description: t('importModule.step-polling-import-desc'),
  },

  'fetching:importDetails': {
    title: t('importModule.step-fetching-summary-title'),
    description: t('importModule.step-fetching-summary-desc'),
  },
})

export const isPendingStep = (step: ImportStep) => {
  return [
    // 'user:uploadFiles',
    'sending:uploadFiles',
    'polling:uploadStatus',
    'fetching:uploadDetails',
    // 'user:mapAndSelect',
    'sending:importData',
    'polling:importStatus',
    'fetching:importDetails',
    // 'user:confirmSummary',
  ].includes(step)
}

export const IMPORT_STATUS_INTERVAL = 1000
export const IMPORT_STATUS_INTERVAL_LONG = 5000
export const IMPORT_STATUS_LONG_INTERVAL_START_ATTEMPT = 11;
